/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type FileUploadRequestType = typeof FileUploadRequestType[keyof typeof FileUploadRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileUploadRequestType = {
  user_avatar: 'user_avatar',
  user_import: 'user_import',
  property_photo: 'property_photo',
  property_note_attachment: 'property_note_attachment',
  invoice_attachment: 'invoice_attachment',
  check_attachment: 'check_attachment',
  vendor_photo: 'vendor_photo',
  property_hma_attachment: 'property_hma_attachment',
} as const;
